var render, staticRenderFns
import script from "./CancelOrder.vue?vue&type=script&lang=js"
export * from "./CancelOrder.vue?vue&type=script&lang=js"
import style0 from "./CancelOrder.vue?vue&type=style&index=0&id=0d41a3b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports